let index = 0

function addIndex() {
	index++
}

export { index, addIndex }
